var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPrincipalAdministration(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 63,
    height: 63,
    viewBox: "0 0 63 63",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4523_1142)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.7925 39.6916C38.797 41.2066 40.0288 42.4311 41.5438 42.4265C43.058 42.4202 44.2814 41.1895 44.2787 39.6752C44.2742 38.1602 43.0424 36.9358 41.5274 36.9403C40.0124 36.9449 38.788 38.1767 38.7925 39.6916ZM40.2155 39.1321C40.439 38.5968 40.9637 38.2495 41.5438 38.2528C42.329 38.2537 42.9653 38.89 42.9662 39.6752C42.9695 40.2553 42.6222 40.78 42.0869 41.0036C41.5515 41.2271 40.9342 41.1052 40.524 40.695C40.1138 40.2848 39.9919 39.6675 40.2155 39.1321Z",
    fill: "#2AA7DF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.1141 47.4567H45.9735H45.9784C46.1932 47.4567 46.3944 47.3516 46.517 47.1753C46.6397 46.999 46.6683 46.7738 46.5937 46.5724C45.8092 44.4887 43.8162 43.1087 41.5898 43.1074H41.5077C39.2795 43.1067 37.284 44.487 36.4989 46.5724C36.4243 46.7738 36.4529 46.999 36.5756 47.1753C36.6982 47.3516 36.8994 47.4567 37.1141 47.4567ZM44.8956 46.1442H38.192C38.9506 45.0639 40.1877 44.4206 41.5077 44.4199H41.5865C42.9045 44.4216 44.1391 45.0649 44.8956 46.1442Z",
    fill: "#2AA7DF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.8069 49.5682L27.6543 49.5305C18.6489 47.3731 11.8584 38.4923 11.8584 28.875V18.4538L27.8069 10.4738L43.7554 18.4538V28.875C43.753 29.7263 43.6982 30.5767 43.5914 31.4213C43.5621 31.654 43.4108 31.8533 43.1947 31.9443C42.9785 32.0353 42.7302 32.004 42.5433 31.8623C42.3565 31.7205 42.2594 31.4899 42.2887 31.2572C42.3889 30.467 42.4404 29.6715 42.4429 28.875V19.2642L27.8069 11.9405L13.1709 19.2642V28.875C13.1709 37.8525 19.4512 46.1393 27.8069 48.2213C28.839 47.963 29.8451 47.6105 30.8125 47.168C31.1424 47.0176 31.5317 47.163 31.6821 47.4928C31.8325 47.8226 31.687 48.2119 31.3572 48.3623C30.2649 48.8615 29.1271 49.2543 27.9595 49.5354L27.8069 49.5682Z",
    fill: "#9DA0A5"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.9463 42.9286C31.9463 48.2292 36.2433 52.5262 41.5439 52.5262C46.8423 52.5208 51.1362 48.227 51.1416 42.9286C51.1416 37.6279 46.8446 33.3309 41.5439 33.3309C36.2433 33.3309 31.9463 37.6279 31.9463 42.9286ZM33.2588 42.9286C33.2588 38.3528 36.9682 34.6434 41.5439 34.6434C46.1175 34.6489 49.8237 38.3551 49.8291 42.9286C49.8291 47.5044 46.1197 51.2137 41.5439 51.2137C36.9682 51.2137 33.2588 47.5044 33.2588 42.9286Z",
    fill: "#2AA7DF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.522 28.6978H16.2095V21.1296L27.8071 15.3267L39.0421 20.9475L38.4531 22.1222L27.8071 16.7934L17.522 21.9401V28.6978V28.6978Z",
    fill: "#9DA0A5"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4523_1142"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 63,
    height: 63,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrincipalAdministration);
export default __webpack_public_path__ + "static/media/principal-administration.2f258ea9f2df4c3f98bbc87436ad0e32.svg";
export { ForwardRef as ReactComponent };